document.addEventListener("DOMContentLoaded", () => {
  //left nav click change right content
  $(".parentnav").click(function () {
    $(".parentnav").removeClass("parentactive");
    $(this).addClass("parentactive");
    var nameid = $(this).attr("data-id");
    $(".mainpage")
      .siblings()
      .removeClass("active")
      .hide()
      .siblings(`${nameid}`)
      .addClass("active")
      .show();
    $(".faq-search-text").val("");
  });

  //left nav
  $(".grid-sider-faq")
    .find(".nav-name")
    .click(function () {
      if ($(this).next(".nav-subcontent").is(":hidden")) {
        $(this).addClass("faq-active");
      } else {
        $(this).removeClass("faq-active");
      }
      $(this).next(".nav-subcontent").slideToggle();
    });

  // faq item toggle
  $(".faq-box .title").click(function () {
    let status = $(this).data("status");
    console.log(status);
    $(this).parent().find(".content").slideToggle();

    if ($(this).find('.show-btn').text() === '+') {
      $(this).find('.show-btn').text('-')
    } else {
      $(this).find('.show-btn').text('+')
    }

    if (!status) {
      $(this).addClass("active");
      $(this).data("status", true);
      return;
    } else {
      $(this).removeClass("active");
      $(this).data("status", false);
      return;
    }

  });

  //get # link
  let alink = window.location.hash;
  if (alink) {
    let nstr = alink.substr(1),
      link_arr = nstr.split("-"),
      link_arr0 = link_arr[0];
    $(".mainpage").removeClass("active");
    $(".parentnav").removeClass("parentactive");
    $('.parentnav[data-id="#' + link_arr0 + '"]').addClass("parentactive");
    $(".mainpage#" + link_arr0).addClass("active");
    $(alink).find(".title").addClass("active");
    $(alink).find(".content").show();
    $(alink).find('.show-btn').text('-')
    $("html,body").animate({ scrollTop: $(alink).offset().top + "px" }, 800);
  }
});
